export const getActiveState = (active: boolean, reverseOperation?: boolean) => (reverseOperation ? !active : active);
